import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import {
  OrganizationCreateType,
  OrganizationEditType,
  StatisticFilterType,
} from '@/shared/types'
import { OrganizationDataMapper } from '@/shared/mappers'

class OrganizationsApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getOrganizations(search: string, count, showOld = false, offset = 0) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/organizations',
      params: {
        search,
        count,
        'show-old': showOld,
        offset,
      },
    })
  }

  public getOrganizationInfo(organizationId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/organizations/${organizationId}`,
    })
  }

  public createOrganization(organization: OrganizationCreateType) {
    const formData =
      OrganizationDataMapper.mapOrganizationCreationData(organization)

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/organizations/create',
      data: formData,
    })
  }

  public removeOrganizationLogo(organizationId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/organizations/${organizationId}/delete-logo`,
    })
  }

  public updateOrganization(
    organizationId: number,
    organization: OrganizationEditType
  ) {
    const formData =
      OrganizationDataMapper.mapOrganizationEditionData(organization)

    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/organizations/${organizationId}/update`,
      data: formData,
    })
  }

  public uploadHistory(historyFile: File) {
    const formData = new FormData()

    formData.append('history', historyFile)

    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/organizations/upload-history`,
      data: formData,
    })
  }

  public getOrganizationStatistic(
    organizationId: number,
    filter: StatisticFilterType
  ) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/organizations/${organizationId}/statistics`,
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }

  public getOrganizationUserStatistic(
    organizationId: number,
    userId: number,
    filter: StatisticFilterType
  ) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/organizations/${organizationId}/${userId}/statistics`,
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }
}

export const organizationsApi = new OrganizationsApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
